var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamping = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#222830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M8.9 19.749c0-5.1 3.1-9.3 7-9.3s7 4.2 7 9.3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#222830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M12.3 19.65c0-3.3 1.6-5.9 3.6-5.9s3.6 2.7 3.6 5.9zM15.9 13.75v5.5M22.9 19.75H1M3.9 19.549v-16.1M6.8 5.95l-2.9-2.8-2.8 2.8M6.8 9.65l-2.9-2.8-2.8 2.8M6.8 13.849l-2.9-2.8-2.8 2.8"
})));
export default SvgCamping;